import { LuxModal, LuxModalHeader, useMediaQuery } from '@gemini/fe-ds-core';
import { ModalMapContainer } from './styles';
import { useTranslation } from 'react-i18next';
import { TabletBreakpoint } from '@utils/consts/breakpoints.consts';
import { DirectionsCardMap } from './DirectionsCardMap';

interface DirectionsModalProps {
  open: boolean;
  onClose: () => void;
}

export function DirectionsModal({ open, onClose }: DirectionsModalProps) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(`(max-width:${TabletBreakpoint}px)`);
  return (
    <>
      <LuxModal
        size="large"
        open={open}
        header={
          <LuxModalHeader
            enableCloseIcon
            onClose={onClose}
            title={t('practiceCard.directions')}
          />
        }
        onClose={onClose}
      >
        <ModalMapContainer isMobile={isMobile}>
          {<DirectionsCardMap />}
        </ModalMapContainer>
      </LuxModal>
    </>
  );
}
